import Tracker from "../../../../../../prop-trackers/tracker.js";
import DictTracker from "../../../../../../prop-trackers/dict-tracker.js";
import PropTracker from "../../../../../../prop-trackers/prop-tracker.js";
import SinglePropTracker from "../../../../../../prop-trackers/single-prop-tracker.js";
import { ForEach, ValueTracker as ForEachValueTracker } from "../../../../../../prop-tracker-utils/for-each.js";

function isEmpty(obj) {
    for (const key in obj) {
        return false;
    }

    return true;
}

class ChildDataGenerator extends Tracker {
    constructor(parentDataTracker, wrapCtx, evtCtx) {
        super();

        this._wrapCtx = wrapCtx;
        this._childData = {};

        this._forEachTracker = new ForEach(parentDataTracker, (key) => new ObjectMapper(evtCtx, key));
        this._outputTracker = new DictTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._forEachTracker.listenNeedsUpdate(needsUpdate);
    }

    protected_startUpdate() {
        this._forEachTracker.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ props }) => {
                    const { oldValue: oldParent, newValue: newParent } = props.get("parent");
                    const { oldValue: oldChild, newValue: newChild } = props.get("child");

                    if (oldParent && oldChild) {
                        const oldParentData = this._childData[oldParent];
                        const oldChildData = this._childData[oldChild];

                        delete oldParentData.children[oldChild];
                        oldChildData.parent = null;

                        if (oldParentData.parent === null && isEmpty(oldParentData.children)) {
                            delete this._childData[oldParent];
                            this._outputTracker.deleteValue(oldParent);
                        }

                        if (oldChildData.parent === null && isEmpty(oldChildData.children)) {
                            delete this._childData[oldChild];
                            this._outputTracker.deleteValue(oldChild);
                        }
                    }

                    if (newParent && newChild) {
                        let newParentData = this._childData[newParent];
                        let newChildData = this._childData[newChild];

                        if (!newParentData) {
                            newParentData = this._wrapCtx.getWrapper({ parent: null, children: {} });
                            this._childData[newParent] = newParentData;
                            this._outputTracker.setValue(newParent, newParentData);
                        }

                        if (!newChildData) {
                            newChildData = this._wrapCtx.getWrapper({ parent: null, children: {} });
                            this._childData[newChild] = newChildData;
                            this._outputTracker.setValue(newChild, newChildData);
                        }

                        newParentData.children[newChild] = true;
                        newChildData.parent = newParent;
                    }
                });
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        return this._outputTracker.finishUpdate();
    }
}

class ObjectMapper extends ForEachValueTracker {
    constructor(evtCtx, key) {
        super();

        this._evtCtx = evtCtx;
        this._key = key;

        this._parentTracker = new SinglePropTracker();
        this._outputTracker = new DictTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._parentTracker.listenNeedsUpdate(needsUpdate);
        this._outputTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(data) {
        if (data) {
            this._parentTracker.track(data, this._evtCtx.getEvents(data), "parent");
            this._outputTracker.setValue("child", this._key);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._parentTracker.track();
        this._outputTracker.deleteValue("child");
    }

    protected_startUpdate() {
        this._parentTracker.updateIfNeeded(({ prop: { newValue } }) => {
            if (newValue) {
                this._outputTracker.setValue("parent", newValue);
            } else {
                this._outputTracker.deleteValue("parent");
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._outputTracker.finishUpdate();
    }
}

export default ChildDataGenerator;
